import { REQUEST_UNREAD_MENTION_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: {}, errors: null };

export default function unreadMention(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case REQUEST_UNREAD_MENTION_SUCCESS:
     
      return { ...state, data: action.payload, errors: null }
    default:
      return state;
  }
}
